import { BillingTier } from "types/generated";

import { V5_TIERS_SEQUENCE } from "../constants";

const V5_LADDER_EQUIVALENT: Partial<Record<BillingTier, BillingTier>> = {
  [BillingTier.V4Free]: BillingTier.V5Free,
  [BillingTier.V4Starter]: BillingTier.V5Starter,
  [BillingTier.V4StarterPlus]: BillingTier.V5StarterPlus,
  [BillingTier.V4Business]: BillingTier.V5Business,
  [BillingTier.V4Enterprise]: BillingTier.V5Enterprise,
};

const toLadderTier = (tier: BillingTier): BillingTier | undefined =>
  V5_LADDER_EQUIVALENT[tier] ?? (V5_TIERS_SEQUENCE.includes(tier) ? tier : undefined);

// Marketing cards strictly above the account's position; empty for the top tiers and legacy/V3.
export const getUpgradeTiers = (
  tier: BillingTier,
  marketingTiers: BillingTier[]
): BillingTier[] => {
  const current = toLadderTier(tier);
  if (!current) return [];

  const position = V5_TIERS_SEQUENCE.indexOf(current);

  return marketingTiers.filter(
    (marketingTier) => V5_TIERS_SEQUENCE.indexOf(marketingTier) > position
  );
};

export const getPreviousBillingTier = (
  tier: BillingTier,
  marketingTiers: BillingTier[]
): BillingTier | undefined => {
  const current = toLadderTier(tier);
  if (!current) return undefined;

  // Free sits below Starter on the ladder used for the cards' "All from ..." header.
  const ladderWithFree = [BillingTier.V5Free, ...marketingTiers];
  const index = ladderWithFree.indexOf(current);
  if (index <= 0) return undefined;

  return ladderWithFree[index - 1];
};
